// extracted by mini-css-extract-plugin
module.exports = {"blockContainer":"Looks_blockContainer__D8egh"};